import { Box, Stack, Typography } from '@mui/material';
import { Fragment } from 'react';
import { Roi } from '~/domain/dicom/dicomstructureset';
import useRoi from '~/hooks/structure-set/useRoi';
import ReviewControls from './ReviewControls';
import ReviewPlayer from './ReviewPlayer';
import StructureInformation from './StructureInformation';

export default function ReviewStructure({ structure }: { structure: Roi }) {
    const {
        roi,
        setRoiApprovalStatus,
        setInterpretedType,
        setRoiDescription,
        structureCanBeEdited,
        getRoiVolumeCm3,
        getRoiEquivalentSphereDiameter,
    } = useRoi(structure);

    return roi ? (
        <Fragment>
            <Stack gap={1} direction="column">
                <ReviewPlayer roi={roi} />

                <Box mt={1}>
                    <StructureInformation
                        roi={roi}
                        isEditable={structureCanBeEdited}
                        onInterpretedTypeChange={setInterpretedType}
                        onDescriptionChange={setRoiDescription}
                        getRoiVolumeCm3={getRoiVolumeCm3}
                        getRoiEquivalentSphereDiameter={
                            getRoiEquivalentSphereDiameter
                        }
                    />
                </Box>
            </Stack>
            <Stack spacing={1} marginTop={3}>
                <ReviewControls
                    roi={roi}
                    onStatusChange={setRoiApprovalStatus}
                />
            </Stack>
        </Fragment>
    ) : (
        <Typography variant="body2">
            No structure selected.
            <br />
            In order to start reviewing select one structure from the list.
        </Typography>
    );
}
